<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->
                <mdb-card-title>
                    <!-- Project Title -->
                    <h2>NAVI, UNE APPLICATION D'ANNOTATION DE DOCUMENTS ANCIENS</h2>
                    <!-- Project date + duration -->
                    <h4><b>Fin :</b> Juin 2020</h4>
                    <h4><b>Durée :</b> 10 mois</h4>
                </mdb-card-title>
                <!-- Project image -->
                <mdb-card-img class="project-picture" src="assets/NAV_proj.jpg"></mdb-card-img>
                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/python.png" />
                                <img class="dot" src="assets/skills/qt.png" />
                                <img class="dot" src="assets/skills/opencv.png" />
                                <img class="dot" src="assets/skills/gitlab.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p>Python, OpenCV, SQLite, UI</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>
                                Dans le cadre du module d'Etude Pratique en 3e année de département informatique à l'Insa de Rennes, j'ai eu l'occasion de participer à mon premier projet informatique en équipe. L'objectif de ce projet était de réaliser une <b>application</b>                                permettant de <b>simplifier</b> l'annotation de documents anciens. Nous avions à disposition une base d'images qui étaient des registres militaires du Régiment du Limousin datant du XVIIe siècle.<br> Ces documents ayant
                                une nature générique (voir les tableaux sur les illustrations ci-dessous), l'annotation est vite répétitive, l'idée était alors de simplifier un maximum la navigation au coeur des documents. Ainsi, nous avons tenté de mettre
                                en place de la reconnaissance d'image à l'aide d'<b>OpenCV</b> pour détecter les cases de tableaux et pouvoir se déplacer de l'une à l'autre à l'aide du clavier. L'interface utilisateur réalisée à l'aide de <b>Qt</b> est
                                inspirée de logiciels permettant la manipulation d'images tel que <b>Gimp</b>.
                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>
                                Au cours de ce projet, j'ai pu découvrir dans un premier temps le travail en équipe dans un contexte informatique. Nous avons fonctionné lors de ce projet avec des méthodologies se rapprochant de l'<b>Agile</b> : réunions
                                fréquentes, mise au point sur les fonctionnalités, ajustement au besoin, etc. J'ai également pu découvrir l'utilisation de <b>Git</b> et rencontré mes premiers problèmes avec (travail sur une branche unique en concurrence,
                                erreurs de merge, perte de code, etc.). C'est grâce à tout ces problèmes que j'ai pu en apprendre énormément. <br> Parallèlement à ça, la composante historique du sujet m'a beaucoup plu et m'a permis de voir l'informatique
                                sous un nouvel angle. <br> Ce projet fut ma première vraie expérience en projet et elle fut très enrichissante sur de nombreux points.
                            </p>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
            <!-- Images of the project -->
            <!-- TODO: add images from project -->
            <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/projects/adda/aperçu.png" alt="Aperçu application">
                </mdb-carousel-item>
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/projects/adda/lines.png" alt="Aperçu détection lignes">
                </mdb-carousel-item>
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/projects/adda/mockup.png" alt="Schéma de l'application">
                </mdb-carousel-item>
            </mdb-carousel>
            <!-- Video TODO: ajouter une vidéo où on joue au jeu-->
            <h4 class="video-title"><b>Résultat :</b></h4>
            <div class="row">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/pc8DzdCSE7U" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="video">
        </iframe>
            </div>
        </div>
    </div>
</div>

<app-projects></app-projects>